document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.essentials-shop');

  sections.forEach(function (section) {
    initEssentialsSection(section);
  });

  function initEssentialsSection(section) {
    initGallery(section);
    initPurchase(section);
  }

  function initGallery(section) {
    var gallery = section.querySelector('[data-essentials-gallery]');
    if (!gallery) return;

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var requestedGallerySet = null;
    var requestedSlideIndex = 0;
    var galleryRequestId = 0;

    function getGallerySets() {
      return Array.from(gallery.querySelectorAll('[data-gallery-set]'));
    }

    function getActiveGallerySet() {
      return gallery.querySelector('[data-gallery-set].is-active');
    }

    function getSlides(gallerySet) {
      return gallerySet ? Array.from(gallerySet.querySelectorAll('[data-gallery-slide]')) : [];
    }

    function getDots(gallerySet) {
      return gallerySet ? Array.from(gallerySet.querySelectorAll('[data-gallery-dot]')) : [];
    }

    function getActiveIndex() {
      var activeGallerySet = requestedGallerySet || getActiveGallerySet();
      if (!activeGallerySet) return 0;

      if (activeGallerySet === requestedGallerySet) {
        return requestedSlideIndex;
      }

      var slides = getSlides(activeGallerySet);
      var activeIndex = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });

      return activeIndex >= 0 ? activeIndex : 0;
    }

    function preloadGalleryImages() {
      var images = Array.from(gallery.querySelectorAll('.essentials-shop__slide-image'));

      images.forEach(function (image) {
        image.loading = 'eager';
        image.decoding = 'async';
      });
    }

    function whenImageReady(image, callback) {
      if (!image) {
        callback();
        return;
      }

      function finishAfterDecode() {
        if (typeof image.decode !== 'function') {
          callback();
          return;
        }

        image.decode().catch(function () {
          return null;
        }).then(callback);
      }

      if (image.complete && image.naturalWidth > 0) {
        finishAfterDecode();
        return;
      }

      image.addEventListener('load', finishAfterDecode, { once: true });
      image.addEventListener('error', callback, { once: true });
    }

    function activateGalleryView(gallerySet, index) {
      var gallerySets = getGallerySets();
      var slides = getSlides(gallerySet);
      var dots = getDots(gallerySet);

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === index;

        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });

      gallerySets.forEach(function (item) {
        item.classList.toggle('is-active', item === gallerySet);
      });
    }

    function requestGalleryView(gallerySet, index) {
      var slides = getSlides(gallerySet);
      if (!slides.length) return;

      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      requestedGallerySet = gallerySet;
      requestedSlideIndex = index;

      var requestId = ++galleryRequestId;
      var targetImage = slides[index].querySelector('.essentials-shop__slide-image');

      whenImageReady(targetImage, function () {
        if (requestId !== galleryRequestId) return;

        activateGalleryView(gallerySet, index);
      });
    }

    function goToSlide(index) {
      var gallerySet = requestedGallerySet || getActiveGallerySet();
      if (!gallerySet) return;

      requestGalleryView(gallerySet, index);
    }

    function switchGallery(optionKey) {
      var gallerySets = getGallerySets();
      var nextGallerySet = null;

      if (gallery.dataset.gallerySource === 'custom') {
        nextGallerySet = gallerySets[0] || null;
      } else {
        nextGallerySet = gallerySets.find(function (item) {
          return item.dataset.galleryKey === optionKey;
        }) || null;
      }

      if (!nextGallerySet) return;

      requestGalleryView(nextGallerySet, 0);
    }

    function goToMediaId(mediaId) {
      var gallerySet = requestedGallerySet || getActiveGallerySet();
      if (!gallerySet || !mediaId) return;

      var slides = getSlides(gallerySet);
      var matchingIndex = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId) === String(mediaId);
      });

      if (matchingIndex >= 0) {
        requestGalleryView(gallerySet, matchingIndex);
      }
    }

    gallery.addEventListener('click', function (event) {
      var dot = event.target.closest('[data-gallery-dot]');
      if (!dot) return;

      goToSlide(parseInt(dot.dataset.slideTarget, 10) || 0);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToSlide(getActiveIndex() - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToSlide(getActiveIndex() + 1);
      });
    }

    section.__essentialsSwitchGallery = switchGallery;
    section.__essentialsGoToMediaId = goToMediaId;

    preloadGalleryImages();

    var initialOptionBtn = section.querySelector('[data-option-btn].is-active');
    if (initialOptionBtn) {
      switchGallery(initialOptionBtn.dataset.optionKey || '');
    } else {
      requestedGallerySet = getActiveGallerySet();
      goToSlide(0);
    }
  }

  function initPurchase(section) {
    var configEl = section.querySelector('[data-essentials-config]');
    if (!configEl) return;

    var config = {};

    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      config = {};
    }

    var optionButtons = Array.from(section.querySelectorAll('[data-option-btn]'));
    var optionSelect = section.querySelector('[data-option-select]');
    var qtyButtons = Array.from(section.querySelectorAll('[data-qty-btn]'));
    var qtyGroup = section.querySelector('[data-qty-grid]');
    var qtyGroupLabel = section.querySelector('[data-qty-grid]') ? section.querySelector('[data-qty-grid]').closest('.essentials-shop__group') : null;
    var addToCartBtn = section.querySelector('[data-essentials-atc]');
    var tryOnceBtn = section.querySelector('[data-essentials-try-once]');
    var tryOnceText = section.querySelector('[data-try-once-text]');
    var tryOnceTemplate = tryOnceBtn ? (tryOnceBtn.dataset.tryOnceTemplate || 'TRY IT ONCE ($)') : 'TRY IT ONCE ($)';

    var priceDisplay = section.querySelector('[data-price-display]');
    var comparePriceDisplay = section.querySelector('[data-compare-price-display]');
    var savingsValue = section.querySelector('[data-savings-value]');
    var ctaPrice = section.querySelector('[data-cta-price]');
    var offerBadge = section.querySelector('[data-offer-badge]');
    var defaultOfferBadgeText = offerBadge ? offerBadge.textContent.trim() : '';

    if (!addToCartBtn) return;

    var cliniciansChoiceMount = section.querySelector('[data-essentials-clinicians-choice]');
    var cliniciansChoiceBadge = cliniciansChoiceMount
      ? cliniciansChoiceMount.querySelector('[data-essentials-clinicians-choice-badge]')
      : null;
    var optionSelectWrap = section.querySelector('[data-option-select-wrap]');
    var optionSelectBadge = section.querySelector('[data-option-select-badge]');
    var cliniciansChoiceRequestId = 0;
    var cliniciansChoiceTransitionTimer = null;
    var cliniciansChoiceTransitionDuration = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 0
      : 360;

    function updateOptionSelectBadge(badgeText) {
      if (!optionSelectBadge) return;

      var nextBadgeText = String(badgeText || '').trim();

      if (!nextBadgeText) {
        optionSelectBadge.textContent = '';
        optionSelectBadge.classList.add('is-hidden');

        if (optionSelectWrap) {
          optionSelectWrap.classList.remove('has-select-badge');
        }

        return;
      }

      optionSelectBadge.textContent = nextBadgeText;
      optionSelectBadge.classList.remove('is-hidden');

      if (optionSelectWrap) {
        optionSelectWrap.classList.add('has-select-badge');
      }
    }

    function getSelectedFrontrowProductId() {
      if (!optionSelect) return '';

      var selectedOption = optionSelect.options[optionSelect.selectedIndex];

      if (!selectedOption) {
        updateOptionSelectBadge('');
        return '';
      }

      updateOptionSelectBadge(selectedOption.dataset.selectBadgeText || '');

      return selectedOption.dataset.frontrowProductId || '';
    }

    function getCliniciansChoiceActiveLayer() {
      if (!cliniciansChoiceBadge) return null;

      var activeLayer = cliniciansChoiceBadge.querySelector('.essentials-shop__clinicians-choice-layer.is-active');
      if (activeLayer) return activeLayer;

      var existingIframe = cliniciansChoiceBadge.querySelector('[data-essentials-clinicians-choice-iframe]');
      if (!existingIframe) return null;

      activeLayer = document.createElement('div');
      activeLayer.className = 'essentials-shop__clinicians-choice-layer is-active';
      activeLayer.dataset.frontrowProductId = String(
        cliniciansChoiceMount.dataset.essentialsCliniciansChoiceCurrentId || ''
      );

      while (cliniciansChoiceBadge.firstChild) {
        activeLayer.appendChild(cliniciansChoiceBadge.firstChild);
      }

      cliniciansChoiceBadge.appendChild(activeLayer);

      return activeLayer;
    }

    function appendCliniciansChoiceScript(layer, productId) {
      if (!layer || layer.querySelector('[data-essentials-clinicians-choice-script]')) return;

      var script = document.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.src = 'https://app.thefrontrowhealth.com/api/widgets/script?presentation_type=sticker&product_id=' + encodeURIComponent(productId);
      script.setAttribute('data-essentials-clinicians-choice-script', '');

      layer.insertBefore(script, layer.firstChild);
    }

    function updateCliniciansChoiceWidget(frontrowProductId) {
      if (!cliniciansChoiceMount || !cliniciansChoiceBadge) return;

      var requestId = ++cliniciansChoiceRequestId;
      var nextProductId = String(frontrowProductId || '').trim();
      var currentProductId = String(cliniciansChoiceMount.dataset.essentialsCliniciansChoiceCurrentId || '').trim();
      var activeLayer = getCliniciansChoiceActiveLayer();

      if (cliniciansChoiceTransitionTimer) {
        window.clearTimeout(cliniciansChoiceTransitionTimer);
        cliniciansChoiceTransitionTimer = null;
      }

      Array.from(cliniciansChoiceBadge.querySelectorAll('.essentials-shop__clinicians-choice-layer')).forEach(function (layer) {
        if (layer !== activeLayer) {
          layer.remove();
        }
      });

      if (!nextProductId) {
        cliniciansChoiceMount.dataset.essentialsCliniciansChoiceCurrentId = '';

        if (!activeLayer) {
          cliniciansChoiceMount.hidden = true;
          cliniciansChoiceMount.classList.add('is-hidden');
          cliniciansChoiceBadge.innerHTML = '';
          return;
        }

        activeLayer.classList.remove('is-active');
        activeLayer.classList.add('is-leaving');

        cliniciansChoiceTransitionTimer = window.setTimeout(function () {
          if (requestId !== cliniciansChoiceRequestId) return;

          cliniciansChoiceBadge.innerHTML = '';
          cliniciansChoiceMount.hidden = true;
          cliniciansChoiceMount.classList.add('is-hidden');
          cliniciansChoiceTransitionTimer = null;
        }, cliniciansChoiceTransitionDuration);

        return;
      }

      cliniciansChoiceMount.hidden = false;
      cliniciansChoiceMount.classList.remove('is-hidden');

      if (currentProductId === nextProductId && activeLayer) {
        return;
      }

      var nextLayer = document.createElement('div');
      nextLayer.className = 'essentials-shop__clinicians-choice-layer is-pending';
      nextLayer.dataset.frontrowProductId = nextProductId;

      var iframe = document.createElement('iframe');
      iframe.dataset.state = 'max';
      iframe.className = 'iframe-frontrow-sticker';
      iframe.id = 'frontrow-sticker';
      iframe.title = "Clinicians' Choice";
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('data-essentials-clinicians-choice-iframe', '');

      var revealTimer = window.setTimeout(revealNextSticker, 5000);
      var hasRevealed = false;

      function revealNextSticker() {
        if (hasRevealed || requestId !== cliniciansChoiceRequestId || !nextLayer.isConnected) return;

        hasRevealed = true;
        window.clearTimeout(revealTimer);

        window.requestAnimationFrame(function () {
          if (requestId !== cliniciansChoiceRequestId || !nextLayer.isConnected) return;

          if (activeLayer && activeLayer !== nextLayer) {
            activeLayer.classList.remove('is-active');
            activeLayer.classList.add('is-leaving');
          }

          nextLayer.classList.remove('is-pending');
          nextLayer.classList.add('is-active');
          cliniciansChoiceMount.dataset.essentialsCliniciansChoiceCurrentId = nextProductId;

          cliniciansChoiceTransitionTimer = window.setTimeout(function () {
            if (requestId !== cliniciansChoiceRequestId) return;

            if (activeLayer && activeLayer !== nextLayer) {
              activeLayer.remove();
            }

            appendCliniciansChoiceScript(nextLayer, nextProductId);
            cliniciansChoiceTransitionTimer = null;
          }, cliniciansChoiceTransitionDuration);
        });
      }

      iframe.addEventListener('load', revealNextSticker, { once: true });
      iframe.src = 'https://app.thefrontrowhealth.com/api/widgets?presentation_type=sticker&product_id=' + encodeURIComponent(nextProductId);

      nextLayer.appendChild(iframe);
      cliniciansChoiceBadge.appendChild(nextLayer);
    }

    var state = {
      optionKey: '',
      optionMode: 'single',
      productId: '',
      variantId: '',
      bundleVariantIds: [],
      quantity: 1,
      sellingPlanId: '',
      unitPrice: 0,
      unitComparePrice: 0,
      discountPercent: 0,
      qtyVariantId: '',
      qtyMode: ''
    };

    function parsePrice(value) {
      if (typeof value === 'number') return value;
      if (!value) return 0;
      var normalized = String(value).replace(/[^0-9.]/g, '');
      var parsed = parseFloat(normalized);
      return isNaN(parsed) ? 0 : parsed;
    }

    function formatMoney(value) {
      var number = parsePrice(value);
      return '$' + number.toFixed(2);
    }

    function updateTryOnceButton(price) {
      if (!tryOnceText) return;

      var formattedPrice = formatMoney(price);
      var nextText = tryOnceTemplate.indexOf('($)') >= 0
        ? tryOnceTemplate.replace('($)', formattedPrice)
        : tryOnceTemplate + ' ' + formattedPrice;

      tryOnceText.textContent = nextText;
    }

    function getVisibleQtyButtons() {
      return qtyButtons.filter(function (button) {
        return button.style.display !== 'none';
      });
    }

    function getBundleVariantIds(button) {
      var raw = button.dataset.bundleVariantIds || '';

      return raw
        .split(',')
        .map(function (value) {
          return value.trim();
        })
        .filter(function (value) {
          return value !== '';
        });
    }

    function filterQtyButtons(optionKey) {
      var hasVisibleQty = false;

      qtyButtons.forEach(function (button) {
        var matches = (button.dataset.optionKey || '') === optionKey;
        button.style.display = matches ? '' : 'none';

        if (matches) {
          hasVisibleQty = true;
        }
      });

      if (qtyGroupLabel) {
        qtyGroupLabel.style.display = hasVisibleQty ? '' : 'none';
      }
    }

    function activateOption(button) {
      if (!button) return;

      optionButtons.forEach(function (item) {
        item.classList.remove('is-active');
      });

      button.classList.add('is-active');

      state.optionKey = button.dataset.optionKey || '';

      if (optionSelect && optionSelect.value !== state.optionKey) {
        optionSelect.value = state.optionKey;
      }

      updateCliniciansChoiceWidget(getSelectedFrontrowProductId());

      state.optionMode = button.dataset.optionMode || 'single';
      state.productId = button.dataset.productId || '';
      state.variantId = button.dataset.variantId || '';
      state.bundleVariantIds = getBundleVariantIds(button);
      state.unitPrice = parsePrice(button.dataset.price);
      state.unitComparePrice = parsePrice(button.dataset.comparePrice);

      filterQtyButtons(state.optionKey);
      ensureValidQtySelection();
      updateAddToCartState();

      if (typeof section.__essentialsSwitchGallery === 'function') {
        section.__essentialsSwitchGallery(state.optionKey);
      }

      var featuredMediaId = button.dataset.featuredMediaId || '';
      if (featuredMediaId && typeof section.__essentialsGoToMediaId === 'function') {
        section.__essentialsGoToMediaId(featuredMediaId);
      }
    }

    function ensureValidQtySelection() {
      var visibleButtons = getVisibleQtyButtons();

      if (!visibleButtons.length) {
        qtyButtons.forEach(function (button) {
          button.classList.remove('is-active');
        });

        state.quantity = 1;
        state.discountPercent = 0;
        state.sellingPlanId = '';
        state.qtyMode = '';
        state.qtyVariantId = '';
        updatePriceUI();
        return;
      }

      var activeVisibleButton = visibleButtons.find(function (button) {
        return button.classList.contains('is-active');
      });

      if (!activeVisibleButton) {
        qtyButtons.forEach(function (button) {
          button.classList.remove('is-active');
        });

        visibleButtons[0].classList.add('is-active');
        activeVisibleButton = visibleButtons[0];
      }

      activateQty(activeVisibleButton, true);
    }

    function activateQty(button, skipReset) {
      if (!button) return;

      if (!skipReset) {
        qtyButtons.forEach(function (item) {
          item.classList.remove('is-active');
        });
        button.classList.add('is-active');
      }

      state.quantity = parseInt(button.dataset.quantity, 10) || 1;
      state.discountPercent = parseFloat(button.dataset.discountPercent) || 0;
      state.sellingPlanId = button.dataset.sellingPlanId || '';
      state.qtyMode = button.dataset.qtyMode || '';
      state.qtyVariantId = button.dataset.variantId || '';

      if (state.qtyMode === 'variant-sku') {
        state.unitPrice = parsePrice(button.dataset.price);
        state.unitComparePrice = parsePrice(button.dataset.comparePrice);
      }

      updatePriceUI();
      updateAddToCartState();
    }

    function updatePriceUI() {
      var baseTotal = state.unitPrice * state.quantity;
      var compareTotal = (state.unitComparePrice > 0 ? state.unitComparePrice : state.unitPrice) * state.quantity;
      var displayPrice = baseTotal;
      var displayComparePrice = 0;
      var savings = 0;

      if (state.discountPercent > 0) {
        displayComparePrice = compareTotal;
        displayPrice = compareTotal * (1 - state.discountPercent / 100);
        savings = Math.max(0, displayComparePrice - displayPrice);
      } else {
        displayPrice = baseTotal;

        if (compareTotal > baseTotal) {
          displayComparePrice = compareTotal;
          savings = Math.max(0, compareTotal - baseTotal);
        } else {
          displayComparePrice = 0;
          savings = 0;
        }
      }

      if (priceDisplay) {
        priceDisplay.textContent = formatMoney(displayPrice);
      }

      if (ctaPrice) {
        ctaPrice.textContent = formatMoney(displayPrice);
      }

      updateTryOnceButton(baseTotal);

      if (comparePriceDisplay) {
        if (displayComparePrice > displayPrice) {
          comparePriceDisplay.textContent = formatMoney(displayComparePrice);
          comparePriceDisplay.classList.remove('is-hidden');
        } else {
          comparePriceDisplay.textContent = '';
          comparePriceDisplay.classList.add('is-hidden');
        }
      }

      if (savingsValue) {
        savingsValue.textContent = formatMoney(savings);
      }

      if (offerBadge) {
        if (state.discountPercent > 0) {
          offerBadge.textContent = Math.round(state.discountPercent) + '% OFF';
        } else {
          offerBadge.textContent = defaultOfferBadgeText;
        }
      }
    }

    function getSelectionIsValid() {
      if (state.optionMode === 'bundle') {
        return state.bundleVariantIds.length > 0 && Number(state.quantity) > 0;
      }

      if (state.optionMode === 'variant-sku') {
        return Boolean(state.qtyVariantId) && Number(state.quantity) > 0;
      }

      return Boolean(state.variantId) && Number(state.quantity) > 0;
    }

    function updateAddToCartState() {
      var isValid = getSelectionIsValid();

      addToCartBtn.disabled = !isValid;

      if (tryOnceBtn) {
        tryOnceBtn.disabled = !isValid;
      }
    }

    function setButtonLoading(button, isLoading) {
      if (!button) return;

      button.classList.toggle('is-loading', Boolean(isLoading));

      if (isLoading) {
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('aria-busy');
      }
    }

    function clearButtonLoadingState() {
      setButtonLoading(addToCartBtn, false);
      setButtonLoading(tryOnceBtn, false);
    }

    function buildCartItems(includeSellingPlan) {
      var items = [];

      if (state.optionMode === 'bundle') {
        if (!state.bundleVariantIds.length) return items;

        items = state.bundleVariantIds.map(function (variantId) {
          var item = {
            id: variantId,
            quantity: state.quantity
          };

          if (includeSellingPlan && state.sellingPlanId) {
            item.selling_plan = state.sellingPlanId;
          }

          return item;
        });
      } else if (state.optionMode === 'variant-sku') {
        if (!state.qtyVariantId) return items;

        var variantSkuItem = {
          id: state.qtyVariantId,
          quantity: state.quantity
        };

        if (includeSellingPlan && state.sellingPlanId) {
          variantSkuItem.selling_plan = state.sellingPlanId;
        }

        items = [variantSkuItem];
      } else {
        if (!state.variantId) return items;

        var singleItem = {
          id: state.variantId,
          quantity: state.quantity
        };

        if (includeSellingPlan && state.sellingPlanId) {
          singleItem.selling_plan = state.sellingPlanId;
        }

        items = [singleItem];
      }

      return items;
    }

    function submitCartItems(includeSellingPlan) {
      var clickedButton = includeSellingPlan ? addToCartBtn : tryOnceBtn;

      if (!clickedButton || clickedButton.disabled) return;

      var items = buildCartItems(includeSellingPlan);

      if (!items.length) return;

      clearButtonLoadingState();
      setButtonLoading(clickedButton, true);

      addToCartBtn.disabled = true;

      if (tryOnceBtn) {
        tryOnceBtn.disabled = true;
      }

      fetch(config.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }
          return response.json();
        })
        .then(function () {
          window.location.href = config.checkoutUrl || '/checkout';
        })
        .catch(function (error) {
          console.error(error);
          clearButtonLoadingState();
          updateAddToCartState();
        });
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activateOption(button);
      });
    });

    if (optionSelect) {
      optionSelect.addEventListener('change', function () {
        var selectedOptionButton = optionButtons.find(function (button) {
          return (button.dataset.optionKey || '') === optionSelect.value;
        });

        if (selectedOptionButton) {
          activateOption(selectedOptionButton);
        }
      });
    }

    qtyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.style.display === 'none') return;

        qtyButtons.forEach(function (item) {
          item.classList.remove('is-active');
        });

        button.classList.add('is-active');
        activateQty(button, true);
      });
    });

    addToCartBtn.addEventListener('click', function () {
      submitCartItems(true);
    });

    if (tryOnceBtn) {
      tryOnceBtn.addEventListener('click', function () {
        submitCartItems(false);
      });
    }

    var initialOption = section.querySelector('[data-option-btn].is-active') || optionButtons[0];
    if (initialOption) {
      activateOption(initialOption);
    } else {
      ensureValidQtySelection();
      updatePriceUI();
      updateAddToCartState();
    }
  }
});